export default __webpack_public_path__ + "static/media/exit.c3db5c8d.svg";